import $ from 'jquery';
window.$ = window.jQuery = require('jquery')
class FormFunctions {
     editClient = (id) => {
        $('.blur')?.css('filter','blur(8px)');
        let elem = document.getElementById(id);
        elem.style.display="block";
    }
     closeForm = (id) => {
        let elem = document.getElementById(id);
        elem.style.display="none";
        $('.blur')?.css('filter','blur(0px)');
    }
}
 
export default new FormFunctions();